import api from '@/js/api.js';

export async function exportDonations(store, transactionsDonations = null) {
  let transactionsDonationsIdsArray = [];

  if (transactionsDonations) {
    transactionsDonationsIdsArray = transactionsDonations.map((donation) => donation.transactions_donations_id);
  } else {
    transactionsDonationsIdsArray = store.filteredDonations.map((donation) => donation.transactions_donations_id);
  }

  if (transactionsDonationsIdsArray.length === 0) {
    console.error('No transaction IDs found for export.');
    return false;
  }

  try {
    const response = await api.post('/donation-history-export', {
      transactions_donations_ids: transactionsDonationsIdsArray,
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = response.data.url;
    } else {
      window.open(response.data.url, '_blank');
    }
  } catch (error) {
    console.error('Failed to export donations:', error);
    return false;
  }
}
